import React from 'react';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import { getCart } from 'utils/Cookies';
import { getCartDomain } from 'utils/Window';
import SiteNavBDesktop from 'components/SiteNav/SiteNavB/SiteNavBDesktop';
import SiteNavBMobile from 'components/SiteNav/SiteNavB/SiteNavBMobile';

const SiteNavB = (props) => {
  const {
    items = [],
    host,
    ...rest
  } = props;

  // Get the cart cookie "itemsCount" property from the "bag" object
  const cartCookie = getCart(host);
  const { bag = {} } = cartCookie;
  const { itemsCount = 0 } = bag;

  // Get Cart Url based on environment
  const cartUrl = `//${getCartDomain(host)}/cart`;

  // get the children of the first item in the nav tree with children
  const { items: firstChildren = [] } = find(items, ({ items: childItems }) => childItems.length > 0) || {};

  return (
    <nav>
      {items.length > 0 &&
        [
          <SiteNavBDesktop
            key='desktop'
            items={items}
            levelBItems={firstChildren}
            itemsCount={itemsCount}
            cartUrl={cartUrl}
            {...rest}
          />,
          <SiteNavBMobile
            key='mobile'
            globalNavLinks={items}
            mainNavItems={firstChildren}
            itemsCount={itemsCount}
            cartUrl={cartUrl}
            {...rest}
          />,
        ]}
    </nav>
  );
};

SiteNavB.propTypes = {
  /**
  * SiteNavB Items
  */
  items: PropTypes.array.isRequired,
  /**
  * Site Domain
  */
  host: PropTypes.string,
};

export default SiteNavB;
